import React from 'react';

import { ContainerHeader } from '~components';
import { faUserNurse } from '~components/icon';

import ClientsWithCarePlans from './ClientsWithCarePlans';

/**
 * Route-level component for /clients/care-plans (no clientId). Renders the care-plan
 * client list. Deliberately leaves the quick menu expanded — only the per-client view
 * (CarePlanView) narrows it.
 */
const CarePlansPage: React.FC = () => (
  <div className="p-2">
    <ContainerHeader icon={faUserNurse} dataCy="care-plans-header">
      Care Plans
    </ContainerHeader>
    <ClientsWithCarePlans />
  </div>
);

export default CarePlansPage;
